(() => {
  const searchPath = /\/search(?:\/suggest(?:\.json)?)?\/?$/;

  const addPrefixWildcard = (value) => {
    const query = value.trim();
    if (!query || /["():]/.test(query)) return query;

    const terms = query.split(/\s+/);
    const lastTerm = terms.length - 1;
    if (!terms[lastTerm].endsWith('*')) terms[lastTerm] += '*';
    return terms.join(' ');
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/search"]')) return;

      const input = form.querySelector('input[name="q"]');
      if (input) input.value = addPrefixWildcard(input.value);
    },
    true
  );

  const nativeFetch = window.fetch;
  window.fetch = (input, init) => {
    if (typeof input !== 'string') return nativeFetch.call(window, input, init);

    try {
      const url = new URL(input, window.location.origin);
      if (searchPath.test(url.pathname)) {
        const query = url.searchParams.get('q');
        if (query) url.searchParams.set('q', addPrefixWildcard(query));
        input = url.toString();
      }
    } catch (error) {
      // Keep the original request if the URL is not a standard fetch URL.
    }

    return nativeFetch.call(window, input, init);
  };
})();
